<template>
  <div id="admin-test">
    <!-- modals -->
    <modal
      id="question-modal"
      :title="`Test ${questionModal.testId} #${questionModal.seqno + 1}`"
      showBodyYScroll="true"
      margintop="10%"
      bodyMaxHeight="70vh"
      size="md3"
    >
      <div clas="container-fluid">
        <div class="row no-gutters">
          <div v-for="s in [questionModal.sequence]" :key="s.id">
            <div class="col-12">
              <span class="badge badge-light mr-1 mb-4">
                {{ s.question.templateId }}</span
              >
              <span class="badge badge-info mx-1">
                {{ s.question.layoutType }}
              </span>
              <span v-if="s.type == 'detail'" class="badge badge-primary mx-1">
                {{ s.type }}
              </span>
              <span
                v-if="s.type == 'simple'"
                class="badge badge-secondary mx-1"
              >
                {{ s.type }}
              </span>
            </div>
            <div class="col-12">
              <div id="q-en" class="col-12 mb-3">
                <b> Question (en) </b> <br /><small
                  >(hash: {{ s.question.key }})</small
                >
              </div>
              <div class="col-12 my-2" v-if="s.question.content">
                <span
                  class="clear question-content"
                  v-html="s.question.content"
                />
              </div>
              <div class="col-12 my-2" v-if="s.question.contentImageData">
                <img
                  class="content-image"
                  v-bind:src="
                    'data:image/jpeg;base64,' + s.question.contentImageData
                  "
                />
              </div>
              <div class="col-12 my-2" v-if="s.question.answers">
                <ul class="ans-lists">
                  <template v-for="(a, i) in s.question.answers">
                    <li class="answer-style" :key="i">
                      <span>{{ listChar(i) + '. ' }}</span>
                      <span class="mj" v-html="a" />
                    </li>
                  </template>
                </ul>
              </div>
              <div class="col-12 my-2" v-if="s.question.answerImagesData">
                <ul class="ans-lists">
                  <template v-for="(a, i) in s.question.answerImagesData">
                    <li class="answer-style" :key="i">
                      <span>{{ listChar(i) }}</span>
                      <img
                        class="answer-image"
                        v-bind:src="'data:image/jpeg;base64,' + a"
                      />
                    </li>
                  </template>
                </ul>
              </div>
              <div class="col-12 my-2" v-if="s.question.solution">
                <div class="table-wrapper">
                  <table class="table">
                    <tr>
                      <th style="min-width:75px">Line #</th>
                      <th></th>
                    </tr>
                    <tr v-for="(rows, j) in s.question.solution" :key="j">
                      <td>{{ j + 1 }}</td>
                      <td>
                        <span
                          v-if="rows.type === 'text_left'"
                          class="example-row align-center mj"
                          v-html="rows.data"
                        />
                        <span
                          v-if="rows.type === 'text_center'"
                          class="example-row align-center mj"
                          v-html="rows.data"
                        />
                        <div
                          v-if="rows.type === 'img'"
                          class="example-row example-image align-center"
                        ></div>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
            <div id="q-zh" class="col-12 mb-3">
              <b> Question (zh) </b> <br /><small
                >(hash: {{ s.refQuestion.key }})</small
              >
            </div>
            <div class="col-12 my-2" v-if="s.refQuestion.content">
              <span
                class="clear question-content"
                v-html="s.refQuestion.content"
              />
            </div>
            <div class="col-12 my-2" v-if="s.question.contentImageData">
              <img
                class="content-image"
                v-bind:src="
                  'data:image/jpeg;base64,' + s.question.contentImageData
                "
              />
            </div>
            <div class="col-12 my-2" v-if="s.refQuestion.answers">
              <ul class="ans-lists">
                <template v-for="(a, i) in s.refQuestion.answers">
                  <li class="answer-style" :key="i">
                    <span>{{ listChar(i) + '. ' }}</span>
                    <span class="mj" v-html="a" />
                  </li>
                </template>
              </ul>
            </div>
            <div class="col-12 my-2" v-if="s.question.answerImagesData">
              <ul class="ans-lists">
                <template v-for="(a, i) in s.question.answerImagesData">
                  <li class="answer-style" :key="i">
                    <span>{{ listChar(i) }}</span>
                    <img
                      class="answer-image"
                      v-bind:src="'data:image/jpeg;base64,' + a"
                    />
                  </li>
                </template>
              </ul>
            </div>
            <div class="col-12 my-2" v-if="s.refQuestion.solution">
              <div class="table-wrapper">
                <table class="table">
                  <tr>
                    <th style="min-width:75px">Line #</th>
                    <th></th>
                  </tr>
                  <tr v-for="(rows, j) in s.refQuestion.solution" :key="j">
                    <td>{{ j + 1 }}</td>
                    <td>
                      <span
                        v-if="rows.type === 'text_left'"
                        class="example-row align-center mj"
                        v-html="rows.data"
                      />
                      <span
                        v-if="rows.type === 'text_center'"
                        class="example-row align-center mj"
                        v-html="rows.data"
                      />
                      <div
                        v-if="rows.type === 'img'"
                        class="example-row example-image align-center"
                      ></div>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </modal>

    <div class="container-fluid">
      <div class="row">
        <div class="col-md-5">
          <table class="table table-hover">
            <thead class="thead-dark">
              <tr>
                <th>Tests #</th>
                <th>Assigned To</th>
                <th>Submitted/Total</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="t in tests">
                <tr
                  :key="t.id"
                  @click="localEventHandler('click-test', { id: t.id })"
                  :class="{
                    clickable: true,
                    'table-active': state.selectTestId == t.id
                  }"
                >
                  <td>{{ t.id }}</td>
                  <td v-if="t.assignedTo">
                    {{ `${t.assignedTo.name} (${t.assignedTo.id})` }}
                  </td>
                  <td v-else>-</td>
                  <td>
                    {{ `${t.numSubmittedSequence} / ${t.numSequence}` }}
                    <i
                      v-if="t.numSubmittedSequence == t.numSequence"
                      class="fa fa-check text-success"
                    />
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
        <div class="col-md-7">
          <div v-if="state.selectTest > -1">
            <div
              v-for="selectedTest in [tests[state.selectTest]]"
              :key="selectedTest.id"
            >
              <h5>Test {{ selectedTest.id }}</h5>
              <div class="list-group my-4">
                <a
                  v-for="(s, i) in selectedTest.sequences"
                  class="list-group-item list-group-item-action clickable"
                  @click="
                    localEventHandler('select-sequence', {
                      testId: selectedTest.id,
                      seqno: i,
                      sequence: JSON.parse(JSON.stringify(s))
                    })
                  "
                  :key="s.id"
                >
                  <div class="d-flex w-100">
                    <span v-if="s.submitted">
                      <i class="fa fa-check text-success" />
                    </span>
                    <b>
                      <span>#{{ i + 1 }}</span>
                    </b>
                    <span class="badge badge-light mx-1">
                      {{ s.question.templateId }}</span
                    >
                    <span class="badge badge-info mx-1">
                      {{ s.question.layoutType }}
                    </span>
                    <span
                      v-if="s.type == 'detail'"
                      class="badge badge-primary mx-1"
                    >
                      {{ s.type }}
                    </span>
                    <span
                      v-if="s.type == 'simple'"
                      class="badge badge-secondary mx-1"
                    >
                      {{ s.type }}
                    </span>
                  </div>
                  <div class="d-flex w-100">
                    <span
                      class="question-content my-2"
                      v-html="
                        `${s.question.content.slice(0, 100)}${
                          s.question.content.length > 100 ? '...' : ''
                        }`
                      "
                    />
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api_admin_test from '@/api/api_admin_test'
import Modal from '@/components/Modal.vue'

export default {
  name: 'AdminTest',
  components: {
    modal: Modal
  },
  data () {
    return {
      state: {
        loadingTest: false,
        loadingTestDetail: false,
        selectTest: -1
      },
      tests: [],
      questionModal: {
        testId: null,
        sequence: { question: {}, refQuestion: {} }
      }
    }
  },
  created () {
    this.state.loadingTest = true
    this.state.batchId = sessionStorage.batchId
    this.fetchTests()
  },
  updated () {
    renderMathInElement($('#admin-test')[0], {
      delimiters: [
        { left: '$$', right: '$$', display: true },
        { left: '$', right: '$', display: false }
      ]
    })
  },

  methods: {
    fetchTests () {
      return api_admin_test.get_tests(this.state.batchId).then(tests => {
        this.tests = tests
        this.tests.sort((a, b) => {
          Number(a.id) - Number(b.id)
        })
      })
    },
    fetchTestDetail (testid) {
      this.state.loadingTestDetail = true
      return api_admin_test.get_test_detail(testid).then(test => {
        var i = this.tests.findIndex(x => x.id == testid)
        if (i != -1) {
          Object.assign(test, this.tests[i])
          this.tests.splice(i, 1, test)
        }
        this.state.loadingTestDetail = false
      })
    },
    fetchQuestionImage (q) {
      return api_admin_test.add_images_to_question(q)
    },
    localEventHandler (name, event) {
      if (name == 'click-test') {
        this.fetchTestDetail(event.id).then(_ => {
          this.state.selectTest = this.tests.findIndex(x => x.id == event.id)
        })
      } else if (name == 'select-sequence') {
        $('#question-modal').modal('show')
        this.questionModal.testId = event.testId
        this.questionModal.seqno = event.seqno
        this.questionModal.sequence = event.sequence
        this.fetchQuestionImage(event.sequence.question).then(_ => {
          this.$forceUpdate()
        })
      }
    },
    listChar (num) {
      return String.fromCharCode(65 + num)
    }
  }
}
</script>
<style scoped>
#admin-test {
  font-size: 10pt;
}
.clickable {
  cursor: pointer;
}

.ans-lists {
  list-style-type: none;
  width: 100%;
  padding-inline-start: 10px !important;
}
.answer-style {
  padding: 10px 10px;
  margin: 5px 5px;
  font-size: 20px;
  border-radius: 23px;
  border: solid 1px #979797;
  display: inline-block;
}

.answer-image {
  max-width: 300px;
  vertical-align: text-top;
}

.content-image {
  max-width: 350px;
  vertical-align: text-top;
}
.clear {
  all: none;
}
.question-content {
  font-size: 20px;
}
</style>
